import {
  ADD_GROUP,
  ADD_INPUT_BOX,
  DELETE_INPUT_BOX,
  SHOW_FLASH_CARDS,
} from "../actionTypes";

// -------- add input box
export const addInputBox = (data) => ({
  type: ADD_INPUT_BOX,
  payloade: data,
});

// --------- delete input box
export const deleteInputBox = (data) => ({
  type: DELETE_INPUT_BOX,
  payloade: data,
});

// --------- add group
export const addGroup = (data) => ({
  type: ADD_GROUP,
  payloade: data,
});

// --------- show flashcards
export const showFalshCard = (data) => ({
  type: SHOW_FLASH_CARDS,
  payloade: data,
});
